import { Space, Tooltip, Typography, theme } from 'antd'
import { WarningOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { formatDuration } from '@/shared/lib/format'
import { CLOCK_SKEW_WARN_SECONDS } from './attendanceApi'

interface DeviceClockSkewProps {
  /** Musbat = qurilma soati oldinda. `null` = hali o'lchanmagan */
  seconds: number | null
  /** Qurilmaga sozlangan zona — ogohlantirish matnida ko'rsatiladi */
  timeZone?: string
}

/**
 * Qurilma soati bilan server soati orasidagi farq.
 *
 * <h2>⚠️ NEGA BU USTUN UMUMAN BOR</h2>
 * 2026-08-11 da haqiqiy qurilmada o'lchangan: terminal ekranda Toshkent
 * vaqtini ko'rsatib turgan (18:51), lekin ISAPI javobida uni `+08:00`
 * (Shanghai) deb belgilagan. Ya'ni HAR BIR davomat hodisasi bazaga
 * 3 SOATGA SURILGAN holda tushardi.
 *
 * Bu nosozlikning eng yomon tomoni — u KO'RINMAYDI. Qurilma oldida turgan
 * odam ekranda to'g'ri vaqtni ko'radi, panel ishlaydi, xato log'da yo'q;
 * faqat oylik hisobot haqiqat bilan solishtirilganda bilinardi — o'shanda
 * esa bir oylik ma'lumot allaqachon buzilgan bo'lardi. Shuning uchun farq
 * jadvalda ALOHIDA ustun bo'lib turadi, kartochka ichiga yashirilmaydi.
 *
 * <h2>Nega raqamning o'zi yetarli emas</h2>
 * "3600" degan son operatorga hech narsa demaydi. Ogohlantirish belgisi
 * va tooltip OQIBATNI aytadi: davomat vaqtlari noto'g'ri yoziladi.
 */
export function DeviceClockSkew({ seconds, timeZone }: DeviceClockSkewProps) {
  const { t } = useTranslation()
  // ⚠️ Rang QOTIRILGAN hex bilan emas, token orqali: qorong'i mavzuda
  // qotirilgan sariq fonda o'qilmaydigan bo'lib qoladi (`BarSeriesChart`
  // dagi bilan bir xil sabab).
  const { token } = theme.useToken()

  // ⚠️ "O'lchanmagan" va "farq nol" BOSHQA-BOSHQA holatlar. Bo'sh katak
  // ikkalasini ham "hammasi joyida" qilib ko'rsatardi, holbuki birinchisi
  // — "biz hali bilmaymiz" (qurilma hech qachon javob bermagan).
  if (seconds === null) {
    return (
      <Tooltip title={t('attendance.clockSkewUnknownHint')}>
        <Typography.Text type="secondary">{t('attendance.clockSkewUnknown')}</Typography.Text>
      </Tooltip>
    )
  }

  const magnitude = Math.abs(seconds)
  const text = magnitude === 0 ? t('attendance.clockSkewNone') : formatDuration(magnitude)
  // Ishora ma'noli: musbat = qurilma OLDINDA, manfiy = ORQADA. Buni
  // yo'qotish "qaysi tomonga surilgan" degan savolni javobsiz qoldirardi.
  const signed = seconds > 0 ? `+${text}` : seconds < 0 ? `−${text}` : text

  // ⚠️ `<` , `<=` EMAS: backend `hasSignificantClockSkew()` da chegara
  // `>=` bilan tekshiriladi. Bir soniyalik farq ham panel bilan serverni
  // bir xil qurilma haqida qarama-qarshi xulosaga olib kelardi.
  if (magnitude < CLOCK_SKEW_WARN_SECONDS) {
    return (
      <Tooltip title={t('attendance.clockSkewOkHint', { limit: CLOCK_SKEW_WARN_SECONDS })}>
        <Typography.Text type="secondary">{signed}</Typography.Text>
      </Tooltip>
    )
  }

  return (
    <Tooltip
      title={
        <>
          <div>{t('attendance.clockSkewWarnHint')}</div>
          {timeZone ? <div>{t('attendance.clockSkewZoneHint', { zone: timeZone })}</div> : null}
        </>
      }
    >
      <Space size={4}>
        <WarningOutlined style={{ color: token.colorWarning }} />
        <Typography.Text type="warning">{signed}</Typography.Text>
      </Space>
    </Tooltip>
  )
}
